module.exports = __webpack_public_path__ + "img/devices.1fd686b6.svg";